// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__YHfOI","label":"SetPasswdForm_label__2SmCi"};